import { Routes, Route, useLocation, Link, Navigate } from "react-router-dom";
import ProjectBudget from "../ProjectBudget/ProjectBudget";
import BudgetStructure from "../BudgetStructure/BudgetStructure";
import AddBudgetStructure from "../BudgetStructure/AddBudgetStructure";
import EditBudgetStructure from "../BudgetStructure/EditBudgetStructure";
import AddProjectBudget from "../ProjectBudget/AddProjectBudget";
import EditProjectBudget from "../ProjectBudget/EditProjectBudget";
import DetailsSummaryOffer from "../SummaryOffer/DetailsSummaryOffer";
import "./ProjectCostBudget.css";
import SummaryOffer from "../SummaryOffer/SummaryOffer";
import ProjectDeliverableRevenue from "../ProjectDeliverableRevenue/ProjectDeliverableRevenue";
import AddProjectDeliverableRevenue from "../ProjectDeliverableRevenue/AddProjectDeliverableRevenue";
import EditProjectDeliverableRevenue from "../ProjectDeliverableRevenue/EditProjectDeliverableRevenue";

function ProjectCostBudget() {
  const location = useLocation();

  const hideHeaderAndTabs =
    location.pathname.includes("/budget-structure/add-budget-structure") ||
    location.pathname.includes("/project-budget/add-project-budget") ||
    location.pathname.includes("/project-budget/edit-project-budget") ||
    location.pathname.includes("/budget-structure/edit-budget-structure") ||
    location.pathname.includes("/project-budget/summary-offer/summary-offer-details") ||
    location.pathname.includes("/project-deliverable-revenue/edit-project-deliverable-revenue") ||
    location.pathname.includes("/project-deliverable-revenue/add-project-deliverable-revenue");


  return (
    <div className="project-cost-budget-page">
      <div style={{ display: "flex" }}>
        <div className="page-wrapper" style={{ flex: 1, overflowY: "hidden" }}>
          {!hideHeaderAndTabs && (
            <>
              <h2 className="title">PROJECT COST BUDGET</h2>
              <div className="tabs">
                <Link
                  to="/project-budget/budget-structure"
                  className={location.pathname.includes("/project-budget/budget-structure") ? "tab-button active" : "tab-button"}
                >
                  Budget Structure
                </Link>
                <Link
                  to="/project-budget/project-budget"
                  className={location.pathname.includes("/project-budget/project-budget") ? "tab-button active" : "tab-button"}
                >
                  Project Budget
                </Link>
                <Link
                  to="/project-budget/project-deliverable-revenue"
                  className={location.pathname.includes("/project-budget/project-deliverable-revenue") ? "tab-button active" : "tab-button"}
                >
                  Project Deliverable Revenue
                </Link>
                <Link
                  to="/project-budget/summary-offer"
                  className={location.pathname.includes("/project-budget/summary-offer") ? "tab-button active" : "tab-button"}
                >
                  Summary offer
                </Link>
              </div>
            </>
          )}

          <Routes>
            <Route path="/" element={<Navigate to="/project-budget/project-budget" replace />} />
            <Route path="project-budget" element={<ProjectBudget />} />
            <Route path="project-budget/add-project-budget" element={<AddProjectBudget />} />
            <Route path="project-budget/edit-project-budget" element={<EditProjectBudget />} />
            <Route path="budget-structure" element={<BudgetStructure />} />
            <Route path="budget-structure/add-budget-structure" element={<AddBudgetStructure />} />
            <Route path="budget-structure/edit-budget-structure" element={<EditBudgetStructure />} />
            <Route path="summary-offer" element={<SummaryOffer />} />
            <Route path="summary-offer/summary-offer-details/:id" element={<DetailsSummaryOffer />} />
            <Route path="project-deliverable-revenue" element={<ProjectDeliverableRevenue />} />
            <Route path="project-deliverable-revenue/add-project-deliverable-revenue" element={<AddProjectDeliverableRevenue />} />
            <Route path="project-deliverable-revenue/edit-project-deliverable-revenue" element={<EditProjectDeliverableRevenue />} />

          </Routes>
        </div>
      </div>
    </div>
  );
}

export default ProjectCostBudget;
